import { RadioGroup } from '@/components/shared/RadioGroup';
import { AccordionDataOption } from '@/components/shared/Accordion/AccordionWizard';
import { useSystemSettings } from '@/services/settings/SystemSettingsProvider';
import { useEffect, useMemo, useState } from 'react';
import { OptimiserSolver } from '@/services/optimiser/useSendOptimseRequest';
import strings from '../roster.translations';

export const useOptimiserSolverWizard = () => {
  const optimiserEnabledSolvers = useSystemSettings(state => state.settings.optimiserEnabledSolvers);
  const [selectedSolver, setSelectedSolver] = useState<OptimiserSolver>('geneticAlgorithm');

  const availableSolvers = useMemo(() => {
    const solvers: OptimiserSolver[] = [];

    if (optimiserEnabledSolvers === 'cpSat' || optimiserEnabledSolvers === 'both') {
      solvers.push('cpSat');
    }

    if (optimiserEnabledSolvers === 'geneticAlgorithm' || optimiserEnabledSolvers === 'both') {
      solvers.push('geneticAlgorithm');
    }

    return solvers;
  }, [optimiserEnabledSolvers]);

  const shouldChooseSolver = availableSolvers.length > 1;
  const effectiveSolver = shouldChooseSolver ? selectedSolver : availableSolvers[0];
  const effectiveSolverLabel = strings.optimiseRosters.solvers[effectiveSolver].label;

  useEffect(() => {
    if (!availableSolvers.includes(selectedSolver)) {
      setSelectedSolver(availableSolvers[0]);
    }
  }, [availableSolvers, selectedSolver]);

  const solverWizardChoice = useMemo<AccordionDataOption | undefined>(() => {
    if (!shouldChooseSolver) {
      return undefined;
    }

    return {
      heading: strings.optimiseRosters.selectSolver,
      component: (
        <div className="flex flex-col gap-3">
          <p>{strings.optimiseRosters.selectSolverDescription}</p>
          <RadioGroup
            name="optimiser-solver"
            value={selectedSolver}
            onChange={value => setSelectedSolver(value as OptimiserSolver)}
            fieldSetClasses="flex flex-col gap-3 md:flex-row"
            labelClasses="border rounded-md"
            items={[
              {
                key: 'cpSat',
                value: 'cpSat',
                label: strings.optimiseRosters.solvers.cpSat.label,
                description: strings.optimiseRosters.solvers.cpSat.description
              },
              {
                key: 'geneticAlgorithm',
                value: 'geneticAlgorithm',
                label: strings.optimiseRosters.solvers.geneticAlgorithm.label,
                description: strings.optimiseRosters.solvers.geneticAlgorithm.description
              }
            ].filter(item => availableSolvers.includes(item.value as OptimiserSolver))}
          />
        </div>
      )
    };
  }, [availableSolvers, selectedSolver, shouldChooseSolver]);

  return {
    effectiveSolver,
    effectiveSolverLabel,
    solverWizardChoice
  };
};
